import { render, staticRenderFns } from "./ModalProcessoPermissao.vue?vue&type=template&id=e04c976a&scoped=true"
import script from "./ModalProcessoPermissao.vue?vue&type=script&lang=js"
export * from "./ModalProcessoPermissao.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessoPermissao.vue?vue&type=style&index=0&id=e04c976a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04c976a",
  null
  
)

export default component.exports